import { fromJS } from "immutable"
import {
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoadingDimensions: false,
  dimensionsDrillDown: [],
  divisions: [],
  showDimensionBenchmark: false,
})

function widgetResultByDimensionV2Reducer(state = initialState, action) {
  switch (action.type) {
    case GET_DIMENSIONS_WATCHER:
      return state.set("isLoadingDimensions", true)

    case GET_DIMENSIONS_SUCCESS:
      return state
        .set("isLoadingDimensions", false)
        .set("dimensionsDrillDown", action.payload.dimensions_drill_down)
        .set("divisions", action.payload.divisions)
        .set("showDimensionBenchmark", action.payload.show_dimension_benchmark)

    case GET_DIMENSIONS_FAILED:
      return state
        .set("isLoadingDimensions", false)
        .set("dimensionsDrillDown", [])
        .set("divisions", [])
        .set("showDimensionBenchmark", false)

    default:
      return state
  }
}

export default widgetResultByDimensionV2Reducer
